import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ConfigRepository } from '../../../src/internal/repositories/ConfigRepository';
import { OrderTrackingApiSdk } from '../../../src/api/OrderTrackingApiSdk';
import { IConfig } from '../domain/entities/Config';

export class OrderTrackingServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private orderTrackingApiSdk: OrderTrackingApiSdk;

    constructor() {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.orderTrackingApiSdk = diContainer.get(serviceNames.orderTrackingApiSdk);
    }

    public execute = async () => {
        await this.configRepository.getDefaultConfigs();
        const { region, brand, pgApiTokens, orderTracking } = this.configRepository.config
            .config as IConfig;
        const baseUrl = window.location.origin;
        this.orderTrackingApiSdk.setup({
            regionId: region.id,
            brandId: brand.id,
            token: pgApiTokens.orderTracking,
            baseUrl,
            orderNumberType: orderTracking.orderNumberType
        });
    };
}
